import { toast } from "sonner";
import { api, errMsg, fmt, ts } from "../lib/api";
import { useFetch } from "../lib/useFetch";
import { Btn, Panel, Spinner } from "./common";
import { Switch } from "./ui/switch";

const pct = (v) => (v == null ? "—" : `${v}%`);
const mv = (v) => (v == null ? "—" : `${v > 0 ? "+" : ""}${fmt(v, 2)}%`);
const NAMES = { all: "All BUY signals", approved: "AI approved", rejected: "AI rejected" };

function Summary({ s }) {
  return (
    <div className="custom-scrollbar overflow-x-auto"><table className="tbl w-full" data-testid="ai-review-summary"><thead><tr><th>Group</th><th>Signals</th><th>Hit</th><th>Avg move since</th></tr></thead>
      <tbody>{["all", "approved", "rejected"].map((k) => (
        <tr key={k} data-testid={`ai-review-${k}`}><td>{NAMES[k]}</td><td className="mono">{s[k].count}</td><td className="mono font-bold" data-testid={`ai-review-${k}-hit`}>{pct(s[k].hit_pct)}</td><td className="mono">{mv(s[k].avg_move_pct)}</td></tr>))}
      </tbody></table></div>
  );
}

export const AiReview = () => {
  const { data, reload } = useFetch("/ai-review/backtest", 5000);
  const { data: st, reload: reloadS } = useFetch("/settings");
  const run = async () => { try { await api.post("/ai-review/backtest"); toast.success("AI test started (about 2 minutes)"); reload(); } catch (e) { toast.error(errMsg(e)); } };
  const toggle = async (v) => { try { await api.put("/settings", { ai_review_enabled: v }); toast.success(v ? "AI review ON for new BUY signals" : "AI review OFF"); reloadS(); } catch (e) { toast.error(errMsg(e)); } };
  const s = data?.summary;
  const better = s && s.approved.hit_pct != null && s.all.hit_pct != null && s.approved.hit_pct > s.all.hit_pct;
  return (
    <Panel title="AI review of BUY signals (Claude) · 30-day test" className="mb-3" testid="ai-review-panel"
      right={<Btn variant="ghost" disabled={data?.status === "running"} onClick={run} data-testid="ai-review-run">{data?.status === "running" ? `Testing ${data.done}/${data.total}…` : "Run 30-day test"}</Btn>}>
      {!data ? <Spinner /> : !s ? <p className="text-xs text-slate-500" data-testid="ai-review-empty">{data.status === "running" ? `Test running in the background${data.phase ? ` · ${data.phase}` : ""}${data.total ? ` ${data.done}/${data.total}` : ""} — you can leave this page.` : data.status === "interrupted" ? "Last test was interrupted (server restarted). Press Run 30-day test again." : "No test yet."}</p> : (
        <>
          <Summary s={s} />
          <div className={`mt-2 rounded-sm border px-3 py-2 text-[11px] ${better ? "border-emerald-300 bg-emerald-50 text-emerald-800" : "border-amber-300 bg-amber-50 text-amber-800"}`} data-testid="ai-review-verdict">
            {better ? `AI-approved BUYs hit ${s.approved.hit_pct}% vs ${s.all.hit_pct}% for all - the review helped in this test.`
              : `AI-approved BUYs hit ${pct(s.approved.hit_pct)} vs ${pct(s.all.hit_pct)} for all - the review did NOT improve results in this test. Keeping it OFF is suggested.`}
            {" "}Tested {ts(data.finished_at)} · {s.approved.count} approved / {s.rejected.count} rejected{s.errors ? ` · ${s.errors} errors` : ""}. Small sample; past results do not guarantee future results.
          </div>
        </>
      )}
      <div className="mt-3 flex items-center gap-2 text-xs" data-testid="ai-review-toggle-row">
        <Switch checked={!!st?.ai_review_enabled} onCheckedChange={toggle} disabled={!st} data-testid="ai-review-switch" />
        <span data-testid="ai-review-state">{st?.ai_review_enabled ? "Aktif: every new qualified BUY must be approved by Claude before AI trades or alerts" : "Tidak aktif: BUY signals are not reviewed by AI"}</span>
      </div>
    </Panel>
  );
};
